/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Rebaser, RebaserInterface } from "../Rebaser";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "blockNum",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "totalHappyGawds",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalBlood",
        type: "uint256",
      },
    ],
    name: "Rebase",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldYield",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newYield",
        type: "uint256",
      },
    ],
    name: "YieldChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "accountHasActiveBoon",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "alignedPower",
    outputs: [
      {
        internalType: "enum Power",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "alignedPowerBoost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "autofarmerBoonIds",
    outputs: [
      {
        internalType: "uint16[4]",
        name: "",
        type: "uint16[4]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "blocksPerEpoch",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "blocksTilNextRebase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bloodContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bloodPerGawd",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "bloodShopContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "overallHealth",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "aliveGawds",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "alignedGawds",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "cultBoostPercent",
        type: "uint256",
      },
    ],
    name: "computeReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cultBoost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cultContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentYield",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gawchiContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "gawdHasActiveBoon",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gawdsContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "getAlignedPowersBoost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawdId",
        type: "uint16",
      },
    ],
    name: "getAlignedPowersCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAllCultPopulationsAndBoosts",
    outputs: [
      {
        internalType: "uint16[4]",
        name: "",
        type: "uint16[4]",
      },
      {
        internalType: "uint256[4]",
        name: "",
        type: "uint256[4]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getGawdsCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGawdsCountForCults",
    outputs: [
      {
        internalType: "uint256[4]",
        name: "",
        type: "uint256[4]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getHappyGawdsCount",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "enum Power",
        name: "checkPower",
        type: "uint8",
      },
    ],
    name: "getOverallHealthAndAlignedPowersCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "hasBoon",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "tokenId",
        type: "uint16",
      },
    ],
    name: "isActiveBoon",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastRebaseBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
    ],
    name: "mintForOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextRebaseBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ownersContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "precision",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rebase",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rebaseAvailable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "secondsPerBlock",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Power",
        name: "power",
        type: "uint8",
      },
    ],
    name: "setAlignedPower",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "boost",
        type: "uint256",
      },
    ],
    name: "setAlignedPowersBoost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newBlocks",
        type: "uint256",
      },
    ],
    name: "setBlocksPerEpoch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setBloodContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blood",
        type: "uint256",
      },
    ],
    name: "setBloodPerGawd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setBloodShopContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setCultContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newYield",
        type: "uint256",
      },
    ],
    name: "setCurrentYield",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setGawchiContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setGawdsContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "setOwnersContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "blocks",
        type: "uint16",
      },
    ],
    name: "setSecondsPerBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateLastRebaseBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type RebaserConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RebaserConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Rebaser__factory extends ContractFactory {
  constructor(...args: RebaserConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Rebaser";
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Rebaser> {
    return super.deploy(overrides || {}) as Promise<Rebaser>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Rebaser {
    return super.attach(address) as Rebaser;
  }
  override connect(signer: Signer): Rebaser__factory {
    return super.connect(signer) as Rebaser__factory;
  }
  static readonly contractName: "Rebaser";

  public readonly contractName: "Rebaser";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RebaserInterface {
    return new utils.Interface(_abi) as RebaserInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Rebaser {
    return new Contract(address, _abi, signerOrProvider) as Rebaser;
  }
}
